import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
interface VexuPromoteCardProps {
  enabled: boolean;
  /** Kept for API compatibility; the copy now states the 20% benefit directly. */
  bonusMinutes?: number;
  onToggle: () => void;
}

/** Optional: the AI mentions Vexu to interested callers in exchange for extra monthly minutes. */
export function VexuPromoteCard({
  enabled,
  onToggle
}: VexuPromoteCardProps) {
  const {
    isLight
  } = useTheme();
  return <button type="button" role="switch" aria-checked={enabled} aria-label="Vexu Promote" onClick={onToggle} className={`flex w-full items-center gap-4 rounded-2xl border px-4 py-3 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vexu ${isLight ? 'border-slate-200 bg-white' : 'border-white/10 bg-white/5'}`} data-id="element-383" data-mp="1nac1wviyc6n5">
      <span className="min-w-0 flex-1" data-id="element-384" data-mp="13mcp7f4tupf3">
        <span className={`block text-sm font-semibold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-385" data-mp="ziofapsq3hqo">Vexu Promote</span>
        <span className={`mt-0.5 block text-xs leading-snug ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-386" data-mp="gk5p995s3vbz">
          Let your AI mention Vexu when callers ask about it.{' '}
          <span className={`font-semibold ${isLight ? 'text-vexu-700' : 'text-vexu'}`} data-id="element-387" data-mp="6nj5knp6vabj">Get 20% extra minutes per month.</span>
        </span>
      </span>
      <span aria-hidden className={`h-6 w-10 flex-shrink-0 rounded-full p-0.5 transition-colors duration-200 ${enabled ? 'bg-vexu' : isLight ? 'bg-slate-200' : 'bg-white/10'}`} data-id="element-388" data-mp="bjrs4m5pu5sq">
        <span className={`block h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ${enabled ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-389" data-mp="1485pczozcy38" />
      </span>
    </button>;
}